document.addEventListener('DOMContentLoaded', () => {
  let lastCheck = 0;
  const CHECK_INTERVAL = 500;

  const timer = setInterval(() => {
    const now = Date.now();
    if (now - lastCheck < CHECK_INTERVAL) return;
    lastCheck = now;

    const formEmbed = document.querySelector('#app-embed');
    const contactFormEmbed = document.querySelector('[id="page.contact-template"] #app-embed');
    const isChesapeakeVariant = document.querySelector('body[data-theme-variant="chesapeake"]');

    if (formEmbed) {
      clearInterval(timer);

      const shadow = formEmbed?.shadowRoot;
      const contactFormShadow = contactFormEmbed?.shadowRoot;
      const contactFormStyle = document.createElement('style');

      const style = document.createElement('style');
      style.textContent = `
          @font-face {
              font-family: 'Chaparral';
              src: url("{{ 'chaparral-pro-regular.woff2' | asset_url }}") format('woff2');
              font-weight: 400;
              font-display: swap;
          }

          @font-face {
              font-family: 'Chaparral';
              src: url("{{ 'chaparral-pro-semibold.woff2' | asset_url }}") format('woff2');
              font-weight: 600;
              font-display: swap;
          }

          @font-face {
              font-family: 'Chaparral';
              src: url("{{ 'chaparral-pro-bold.woff2' | asset_url }}") format('woff2');
              font-weight: 700;
              font-display: swap;
          }

          @font-face {
              font-family: 'Eureka';
              src: url("{{ 'eureka-sans-regular.woff2' | asset_url }}") format('woff2');
              font-weight: 400;
              font-display: swap;
          }

          @font-face {
              font-family: 'Eureka';
              src: url("{{ 'eureka-sans-medium.woff2' | asset_url }}") format('woff2');
              font-weight: 500;
              font-display: swap;
          }

          @font-face {
              font-family: 'Eureka';
              src: url("{{ 'eureka-sans-bold.woff2' | asset_url }}") format('woff2');
              font-weight: 700;
              font-display: swap;
          }

          @font-face {
            font-family: 'Avenir';
            src: url("{{ 'avenir-roman.woff2' | asset_url }}") format('woff2');
            font-weight: 400;
            font-display: swap;
          }

          @font-face {
            font-family: 'Avenir';
            src: url("{{ 'avenir-medium.woff2' | asset_url }}") format('woff2');
            font-weight: 500;
            font-display: swap;
          }

          @font-face {
            font-family: 'Avenir';
            src: url("{{ 'avenir-black.woff2' | asset_url }}") format('woff2');
            font-weight: 700;
            font-display: swap;
          }

          @font-face {
            font-family: 'Garamond';
            src: url("{{ 'adobe-garamond-pro-regular.woff2' | asset_url }}") format('woff2');
            font-weight: 400;
            font-style: normal;
            font-display: swap;
          }

          @font-face {
            font-family: 'Garamond';
            src: url("{{ 'adobe-garamond-pro-regular-italic.woff2' | asset_url }}") format('woff2');
            font-weight: 400;
            font-style: italic;
            font-display: swap;
          }

          @font-face {
            font-family: 'Garamond';
            src: url("{{ 'adobe-garamond-pro-semibold.woff2' | asset_url }}") format('woff2');
            font-weight: 700;
            font-style: normal;
            font-display: swap;
          }

          @font-face {
            font-family: 'Garamond';
            src: url("{{ 'adobe-garamond-pro-semibold-italic.woff2' | asset_url }}") format('woff2');
            font-weight: 700;
            font-style: italic;
            font-display: swap;
          }

          * {
            font-family: "Eureka", sans-serif !important;
          }

          ${
            isChesapeakeVariant
              ? ` * {
            font-family: "Avenir", sans-serif !important;
          }`
              : ``
          }

          button[type="button"] > span {
              display: inline-flex !important;
              align-items: center !important;
          }

          button[type="button"],
          input {
              border: 1px solid #6e7577 !important;
              border-radius: 0 !important;
              height: 48px !important;
              padding: 0 15px !important;
              transition: all .3s ease-in-out !important;
              box-shadow: none !important;
              outline: none !important;
          }

          textarea {
              border: 1px solid #6e7577 !important;
              border-radius: 0 !important;
              height: 48px !important;
              transition: all .3s ease-in-out !important;
              box-shadow: none !important;
              outline: none !important;
          }

          label {
              position: relative !important;
              order: -1 !important;
              top: 0 !important;
              left: 0 !important;
              transform: none !important;
              color: #6e7577 !important;
              display: block !important;
              font-size: 16px !important;
              font-weight: 400 !important;
              line-height: 1.6 !important;
              margin: 0 0 4px !important;
          }

          p {
              position: relative !important;
              color: #6e7577 !important;
              display: block !important;
              font-size: 16px !important;
              font-weight: 400 !important;
              line-height: 1.6 !important;
              margin: 0 0 4px !important;
          }

          button[type="submit"] {
              align-items: center !important;
              background-color: #4f7d3c !important;
              border: none !important;
              border-radius: 0 !important;
              color: #fbfbfb !important;
              cursor: pointer !important;
              display: inline-flex !important;
              font-size: 20px !important;
              font-weight: 700 !important;
              justify-content: center !important;
              line-height: 1 !important;
              min-height: 48px !important;
              min-width: 48px !important;
              outline: none !important;
              padding: 0 32px !important;
              position: relative !important;
              text-align: center !important;
              text-decoration: none !important;
              text-transform: uppercase !important;
              transform: perspective(1px) translateZ(0) !important;
              transition: all .5s ease-in-out !important;
              opacity: 1 !important;
              filter: none !important;
              width: fit-content !important;
              margin-top: 32px !important;
          }

          button[type="submit"]:hover {
              background-color: #f78533 !important;
              text-decoration: none !important;
              opacity: 1 !important;
              filter: none !important;
          }

          ${
            isChesapeakeVariant
              ? `button[type="submit"] {
            background-color: #476d8d !important;
            font-size: 16px !important;
            line-height: 1 !important;
          }`
              : ``
          }

          ${
            isChesapeakeVariant
              ? `button[type="submit"]:hover {
              background-color: #64a8ab !important;
          }`
              : ``
          }

          fieldset {
              display: inline-flex !important;
              justify-content: space-between !important;
              flex-wrap: nowrap !important;
              flex-direction: row !important;
              position: relative !important;
          }

          legend {
              display: block !important;
              margin-left: 20px !important;
              color: #878a8e !important;
              cursor: pointer !important;
              display: flex !important;
              flex-flow: row nowrap !important;
              font-size: 20px !important;
              font-weight: 500 !important;
              height: auto !important;
              line-height: 1.6 !important;
              line-height: 22px !important;
              margin: 0 !important;
              padding: 12px 0 12px 32px !important;
              position: relative !important;
              width: calc(100% - 40px) !important;
          }

          fieldset legend + div {
              display: block !important;
              position: absolute !important;
              left: 0 !important;
              top: -45px !important;
              z-index: 2 !important;
              width: 100% !important;
              cursor: pointer !important;
          }

          fieldset legend + div label {
              cursor: pointer !important;
          }

          fieldset legend + div input {
              height: 19px !important;
              width: 19px !important;
              border: 1px solid #878a8e !important;
          }

          fieldset legend + div span {
              display: none;
          }

          button[type="button"],
          input,
          textarea {
              border-color: #cbcbcb !important;
              font-size: 20px !important;
          }

          [aria-label="Success"] > div:nth-child(2) > section > h2 + div {
            position: relative !important;
            margin-left: 20% !important;
          }

          @media screen and (max-width: 767px) {
            #form-container-ref > section > section {
                min-width: calc(100vw - 40px) !important;
                margin-left: auto !important;
                margin-right: auto !important
            }

            fieldset legend + div input {
                margin-top: 12px !important;
            }
          }

          @media screen and (max-width: 480px) {
            fieldset legend + div input {
                margin-top: 0 !important;
            }

            [data-testid="app-router"] {
              min-width: 100vw !important;
              margin-left: 50% !important;
              transform: translateX(-50%) !important;
            }

            [data-testid="app-router"] > section {
              min-width: 100vw !important;
            }

            [aria-label="Success"] > div:nth-child(2) > section > h2 + div {
              margin-left: 15% !important;
            }
          }
      `;

      contactFormStyle.textContent = `
          #form-container-ref > section > section {
              min-width: 775px !important;
              max-width: 775px !important;
              width: 775px !important;
          }

          button[type="button"],
          input,
          textarea {
              border-color: #cbcbcb !important;
              font-size: 20px !important;
          }

          label {
              position: absolute !important;
              order: 0 !important;
              top: 12px !important;
              left: 16px !important;
              margin: 0 !important;
          }

          button[type="button"] {
              z-index: 3 !important;
          }

          p {
              position: absolute !important;
              top: 10px !important;
              left: 16px !important;
              margin: 0 !important;
              z-index: 4 !important;
          }

          button[type="button"]:has(span:nth-child(1):not(:empty)) {
              z-index: 5 !important;
          }

          @media screen and (max-width: 767px) {
              #form-container-ref > section > section {
                  max-width: calc(100vw - 40px) !important;
                  width: calc(100vw - 40px) !important;
                  min-width: calc(100vw - 40px) !important;
                  margin-left: auto !important;
                  margin-right: auto !important
              }
          }
      `;

      if (shadow) {
        shadow.appendChild(style);
      }

      if (contactFormShadow) {
        contactFormShadow.appendChild(contactFormStyle);

        const hideFilledLabels = () => {
          const fields = contactFormShadow.querySelectorAll('input, textarea');

          fields.forEach((field) => {
            const idOrName = field.getAttribute('id') || field.getAttribute('name');
            if (!idOrName) return;

            const safeSelector = CSS.escape(`label-${idOrName}`);

            const label = contactFormShadow.querySelector(`#${safeSelector}`);
            if (!label) return;

            const updateLabelDisplay = () => {
              const hasValue = field.value.trim() !== '';
              label.style.setProperty('display', hasValue ? 'none' : 'block', 'important');
            };

            updateLabelDisplay();
            field.addEventListener('input', updateLabelDisplay);
          });
        };

        hideFilledLabels();
      }
    }
  }, 100);

  setTimeout(() => {
    clearInterval(timer);
  }, 10000);
});
